import AsyncComponent from '../../components/HOC/AsyncComponent';

const AsyncProducts = AsyncComponent(() => import('./Products'));
const AsyncEditCreateProduct = AsyncComponent(() => import('./CreateProduct'));
const AsyncWalletUsers = AsyncComponent(() => import('./Users'));
const AsyncEditUser = AsyncComponent(() => import('./EditUser'));
const AsyncUserProducts = AsyncComponent(() => import('./UserProducts'));
const AsyncCreateEditUserProductAccount = AsyncComponent(() =>
  import('./CreateEditUserProductAccount')
);

export {
  AsyncProducts,
  AsyncEditCreateProduct,
  AsyncWalletUsers,
  AsyncEditUser,
  AsyncUserProducts,
  AsyncCreateEditUserProductAccount,
};



// WEBPACK FOOTER //
// ./src/pages/Investment/index.js